export const metaMap = {
  overview: {
    title: "CDGI Overview | Vision, Mission & Institutional Strength",
    description:
      "Discover the journey of CDGI, a premier engineering college in Madhya Pradesh, known for its commitment to academic excellence and innovation.",
  },
  "institutional-policy": {
    title:
      "CDGI Institutional Policy – Upholding Academic Integrity and Excellence",
    description:
      "Learn about CDGI's institutional policies that ensure academic integrity, quality education, and adherence to regulatory standards in engineering education.",
  },
  "audited-statement": {
    title:
      "CDGI Audited Financial Statements – Transparency in Engineering Education",
    description:
      "Access CDGI's audited financial statements, reflecting our commitment to transparency and accountability in providing quality engineering education.",
  },
  mou: {
    title: "CDGI MOUs – Collaborations Enhancing Engineering Education",
    description:
      "Discover CDGI's MOUs with industry and academic partners, fostering collaborations that enrich our engineering programs and student opportunities.",
  },
  "computer-science-engineering": {
    title: "CDGI - Top Engineering Colleges for Computer Science Engineering",
    description:
      "Join CDGI's Computer Science Engineering program, ranked among top engineering colleges in India. Cutting-edge curriculum and excellent placements.",
  },
  "information-technology-1": {
    title: "CDGI - Best Information Technology Engineering College",
    description:
      "Enroll in CDGI's Information Technology program, offering industry-relevant curriculum and strong placement support in the IT sector.",
  },
  "electronics-andcommnunication-engineering": {
    title: "CDGI - Top Electronics & Communication Engineering College",
    description:
      "Study ECE at CDGI, a leading engineering college in India. NAAC A+ accredited, providing hands-on experience and excellent career opportunities.",
  },
  "mechanical-engineering": {
    title: "CDGI - Best Mechanical Engineering College in Madhya Pradesh",
    description:
      "Pursue Mechanical Engineering at CDGI, known for its robust curriculum, experienced faculty, and strong industry connections.",
  },
  "civil-engineering": {
    title: "CDGI - Top Civil Engineering College in Madhya Pradesh",
    description:
      "Join CDGI's Civil Engineering program, offering comprehensive education and practical exposure to build a successful career in civil engineering.",
  },
  "artificial-intellignce-and-data-science": {
    title:
      "CDGI - Best AI & Data Science Engineering College in Madhya Pradesh ",
    description:
      "Enroll in CDGI's AI & Data Science program, combining cutting-edge technology and real-world applications for future-ready professionals.",
  },
  "computer-science-and-information-technology-1": {
    title: "CDGI - Top CS & IT Engineering College in Madhya Pradesh ",
    description:
      "Study Computer Science and IT at CDGI, offering a blend of theoretical knowledge and practical skills to excel in the tech industry.",
  },
  "cdgi-mba": {
    title: "CDGI - Top MBA Colleges in Indore",
    description:
      "Join CDGI, a leading MBA college in Indore, offering industry-relevant curriculum, experienced faculty, and excellent placement opportunities.",
  },
  bpharma: {
    title: "CDGI - Best B.Pharma Colleges in Indore",
    description:
      "Pursue your Bachelor of Pharmacy at CDGI, one of Indore's top B.Pharma colleges, with state-of-the-art labs and expert faculty.",
  },
  mpharma: {
    title: "CDGI - Top M.Pharma Colleges in Indore",
    description:
      "Advance your pharmaceutical career with an M.Pharma from CDGI, offering specialized programs and research opportunities in Indore.",
  },
  "bachelor-of-business-administration": {
    title: "CDGI - Top BBA Colleges in Indore | BBa Colleges near me",
    description:
      "Pursue your BBA at CDGI, a leading business administration college in Indore, offering industry-relevant curriculum and excellent placement opportunities.",
  },
  "bba-ft": {
    title: "CDGI - Best BBA in Foreign Trade College",
    description:
      "Join CDGI's Best BBA in Foreign Trade College to gain expertise in international business and trade, with a curriculum designed for global market readiness.",
  },

  "bachelor-of-computer-applications": {
    title: "CDGI - Top BCA College in Indore | bca colleges near me",
    description:
      "Enroll in CDGI's BCA college in Indore to build a strong foundation in computer applications, programming, and software development.",
  },
  "bachelor-of-commerce": {
    title: "CDGI - Best Colleges for bcom in madhya pradesh",
    description:
      "Pursue your B.Com at CDGI, offering comprehensive commerce education with a focus on accounting, finance, and business management.",
  },
  //
  "cdips-mba": {
    title: "CDGI - Top MBA Program at CDIPS",
    description:
      "Advance your career with CDIPS MBA at CDGI Indore, featuring industry-aligned curriculum and exceptional placement support.",
  },
  "llb-hons": {
    title: "CDGI - Top LLB Hons College in Indore",
    description:
      "Enroll in CDGI's LLB Hons program to gain in-depth legal knowledge and practical skills for a successful law career.",
  },

  "ba-llb-hons": {
    title: "CDGI - Best BA LLB Hons College in Indore",
    description:
      "Join CDGI's BA LLB Hons program, integrating arts and law education to prepare for diverse legal professions.",
  },
  "bba-llb-hons": {
    title: "CDGI - Top BBA LLB Hons College in Indore",
    description:
      "Pursue BBA LLB Hons at CDGI, combining business administration and law for a dynamic legal career in the corporate world.",
  },
  dpharma: {
    title: "CDGI - Best D.Pharma Colleges in Indore",
    description:
      "Start your pharmaceutical career with CDGI's D.Pharm program, offering practical training and foundational knowledge in pharmacy.",
  },

  "placements-overview": {
    title: "Placement Overview | CDGI Indore",
    description:
      "Explore CDGI's training process, placement drives, career support, and success stories of placed students.",
  },
  "excellent-placements": {
    title: "CDGI – Engineering Colleges with Excellent Placements",
    description:
      "CDGI is known for excellent placements across tech, management, and core sectors. View our success metrics and top recruiters.",
  },
  "about-cdgi": {
    title: "About CDGI | Leading engineering colleges in indore mp",
    description:
      "Learn about CDGI's legacy, academic excellence, and the vision of the Agarwal Group in transforming technical education in MP.",
  },
  "computer-science-and-engineering": {
    title: "Computer Science Engineering | CDGI Indore",
    description:
      "Study CSE at CDGI with hands-on coding, labs, AI modules & top IT placements.",
  },

  "information-technology": {
    title: "B.Tech in Information Technology | CDGI Indore",
    description:
      "Explore IT at CDGI – Build careers in software development, networking, and cloud computing.",
  },
  "department-of-electronics-and-communication": {
    title: "ECE Engineering | CDGI Indore – AICTE Approved",
    description:
      "Learn VLSI, embedded systems & wireless technology at CDGI's ECE department.",
  },
  "department-of-mechanical-engineering": {
    title: "Mechanical Engineering Courses| CDGI – B.Tech in MP",
    description:
      "Study Mechanical Engineering with lab training, CAD, production & industrial visits.",
  },
  "department-of-civil-engineering": {
    title: "Civil Engineering courses | CDGI Indore – Best B.Tech Program",
    description:
      "Build a career in civil engineering with CDGI's strong focus on design, structures & surveying.",
  },
  "artificial-intelligence-and-data-science": {
    title: "B.Tech in AI & Data Science | CDGI Indore",
    description:
      "CDGI offers cutting-edge courses in AI, machine learning & data science with placement-ready training.",
  },
  "computer-science-and-information-technology": {
    title: "B.Tech in Computer Science & IT | CDGI Indore",
    description:
      "Learn software, systems & IT tools in the combined CS & IT program at CDGI.",
  },

  "department-of-management": {
    title: "Department of Management – CDGI Indore",
    description:
      "Learn leadership, innovation & business strategy with CDGI’s Department of Management.",
  },
  "mba-full-time-2years": {
    title: "Full-Time MBA at CDGI Indore | 2-Year PG Program",
    description:
      "Apply for full-time MBA at CDGI with specializations in finance, marketing & more. Industry connect + placements.",
  },
  "mba-marketing-management-2years": {
    title: "MBA in Marketing Management | CDGI Indore",
    description:
      "Learn marketing strategies, digital tools, and branding in CDGI’s 2-year MBA (Marketing) program.",
  },
  "mba-financial-administration-2years": {
    title: "Masters in business administration in finance| CDGI Indore",
    description:
      "Build a strong finance career with CDGI’s MBA in Financial Administration program",
  },
  "about-cdip": {
    title: " About CDIP | Best Pharmacy colleges in mp",
    description:
      "Learn about Chameli Devi Group of Institutions (CDGI) – NAAC A+ accredited, AICTE-approved, and backed by the legacy of Agarwal Group, Indore.",
  },
  "b-pharma": {
    title: "CDIP - B pharma colleges in Indore | pharmacy colleges near me",
    description:
      "Study B.Pharma with clinical labs, research opportunities, and experienced faculty at CDIP.",
  },
  "d-pharma": {
    title: "CDIP - Best D Pharma Course in Indore",
    description:
      "Begin your pharma career with D.Pharma Course at CDGI. Learn drug formulation, dispensing & pharmacy practice.",
  },
  "m-pharma": {
    title: "CDIP - M.Pharma (Pharmaceutics) Colleges in Indore ",
    description:
      "Specialize in pharmaceutics with M.Pharm from CDGI. Advanced research, labs & academic guidance.",
  },
  "about-cdips": {
    title: "About CDIPS | Chameli Devi Institute of Professional Studies",
    description:
      "CDIPS offers industry-focused education in management, IT, and commerce. Explore BBA, BCA, B.Com, and MBA programs in Indore.",
  },
  bba: {
    title: "BBA Course at CDIPS | Best BBA College in Indore",
    description:
      "Study BBA at CDIPS, Indore—NAAC A+ accredited college with skill-based business education and placement support.",
  },
  bca: {
    title: "BCA Course at CDIPS | Top BCA College in Madhya Pradesh",
    description:
      "Enroll in BCA at CDIPS for a strong foundation in computer science, programming, and tech careers.",
  },
  bcom: {
    title: "Bcom Course at CDIPS | Bcom Colleges in Indore",
    description:
      "Build your future in finance, accounting, and business with B.Com at CDIPS—career-focused and academically enriching.",
  },
  "mba-full-time": {
    title: "Full Time MBA at CDIPS |  PG Management Program in Indore",
    description:
      "Join CDIPS’s full-time MBA program with specializations, case-based learning, and corporate placements.",
  },
  "about-cdil": {
    title: "About CDIL | Chameli Devi Institute of Law – CDGI Indore",
    description:
      "Learn about CDIL’s vision, legal faculty, moot court facilities, and legal career preparation in Madhya Pradesh.",
  },
  "llb-hons-3-years": {
    title: "LLB Hons at CDIL | 3-Year Law Program in Indore",
    description:
      "Pursue a 3-year LLB Hons degree at CDIL—BCI approved, practice-oriented program for law graduates.",
  },
  "ba-llb-hons-5-years": {
    title: "BA LLB Hons at CDIL | 5-Year Integrated Law Program",
    description:
      "Study BA LLB (Hons) at CDIL Indore – combining law and humanities with real-world legal exposure and moot court training.",
  },
  "bba-llb-hons-5-years": {
    title: "BBA LLB Hons at CDIL | Business & Law Integrated Program",
    description:
      "Join CDIL’s BBA LLB Hons to learn business law, management, and litigation skills in one integrated 5-year course.",
  },
  "bba-llb-hons-5-years": {
    title: "BBA LLB Hons at CDIL | Business & Law Integrated Program",
    description:
      "Join CDIL’s BBA LLB Hons to learn business law, management, and litigation skills in one integrated 5-year course.",
  },
  "mca": {
    title: " CDGI - Top MCA Colleges in madhya pradesh",
    description:
      "Advance your IT career with CDGI's MCA program, focusing on advanced computing, software development, and industry-relevant skills.",
  },
"master-of-computer-application": {
  title: "MCA Course at CDGI | Master of Computer Applications",
  description: "CDGI's MCA program is designed for tech careers in software, AI, and IT consulting."
}
}